<template>
  <div class="qunti-huaxiang-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="single-line gequyuziyuanfenbu">
        <div class="chart-title">各区域资源分布</div>
        <div class="chart-content">
          <StackBar2
            id="gequyuziyuanfenbu"
            :chartData="gequyuZiyuanFenbuData"
            height="480px"
            unit="家"
            :barWidth="25"
          />
        </div>
      </div>
      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";
import StackBar2 from "@/components/Echarts/StackBar2.vue";

export default {
  name: "YetaiZiyuanFenxiDetail",
  components: {
    ChildModal,
    StackBar2
  },
  props: {},
  data() {
    return {
      gequyuZiyuanFenbuData: null
    };
  },
  mounted() {
    fetch("/data/ZiyuanPinggu/YetaiZiyuanFenxiDetail/GequyuZiyuanFenbu.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.gequyuZiyuanFenbuData = json.data;
      });
  },
  methods: {}
};
</script>

<style scoped lang="less">
.gequyuziyuanfenbu .chart-content {
  transform: translateX(0.1rem);
}
</style>
